// App.js

import { GoogleOAuthProvider } from '@react-oauth/google'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { AppProvider } from './AppContext'
import MessageModal from './admin/components/MessageModal'
import NavHeader from './global/components/NavHeader'
import ProtectedRoute from './scoring/components/ProtectedRoute'
import PlayerProtectedRoute from './scoring/components/PlayerProtectedRoute'
import EventSignInController from './scoring/controllers/EventSignInController'
import PlayerLoginController from './scoring/controllers/PlayerLoginController'

import GolferInfoController from './scoring/controllers/GolferInfoController'
import GroupEntryController from './scoring/controllers/GroupEntryController'
import LeaderboardController from './scoring/controllers/LeaderboardController'
import LeagueMenuController from './scoring/controllers/LeagueMenuController'
import OptionSelectController from './scoring/controllers/OptionSelectController'
import PrizeBoardController from './scoring/controllers/PrizeBoardController'
import RoundResultsController from './scoring/controllers/RoundResultsController'
import ScoreEntryController from './scoring/controllers/ScoreEntryController'
import { useMetaStore } from './scoring/store/MetaStore'
import ErrorView from './scoring/views/ErrorView'
import ShareEventView from './scoring/views/ShareEventView'

import OrgProtected from './admin/components/OrgProtected'
import CourseAdminController from './admin/controllers/CourseAdminController'
import EventController from './admin/controllers/EventController'
import GolferAdminController from './admin/controllers/GolferAdminController'
import LoginController from './admin/controllers/LoginController'
import OrganizationController from './admin/controllers/OrganizationController'
import PrizeAdminController from './admin/controllers/PrizeAdminController'
import ArchiveEventListView from './admin/views/ArchiveEventListView'
import CourseListView from './admin/views/CourseListView'
import EventListView from './admin/views/EventListView'
import GolferListView from './admin/views/GolferListView'
import MenuView from './admin/views/MenuView'
import OrganizationListView from './admin/views/OrganizationListView'
import PrizeListView from './admin/views/PrizeListView'
import GolferDetailView from './stats/views/GolferDetailView'

const App = () => {
  const { show, message, color } = useMetaStore((state) => state.globalModal)
  const closeGlobalModal = useMetaStore((state) => state.closeGlobalModal)

  return (
    <GoogleOAuthProvider clientId="226432640274-k4ub8hoaldf1ccta55vs0c7e8n2tei5e.apps.googleusercontent.com">
      <AppProvider>
        <Router>
          <NavHeader />
          <MessageModal show={show} message={message} borderColor={color} onClose={closeGlobalModal} />
          <Routes>
            <Route path="/player-login" element={<PlayerLoginController />} />
            <Route path="/error" element={<ErrorView />} />
            <Route path="/login" element={<LoginController />} />

            
            {/* Player Protected Routes */}
            <Route element={<PlayerProtectedRoute />}>
              <Route path="/" element={<EventSignInController />} />
              <Route path="/event" element={<OptionSelectController />} />
              <Route path="/event/signin" element={<EventSignInController />} />
              <Route path="/scoreentry" element={<ScoreEntryController />} />
              <Route path="/share" element={<ShareEventView />} />
              <Route path="/groupentry" element={<GroupEntryController />} />
              <Route path="/leaderboard" element={<LeaderboardController />} />
              <Route path="/league" element={<LeagueMenuController />} />
              <Route path="/league/menu" element={<LeagueMenuController />} />
              <Route path="/league/golfers" element={<GolferInfoController />} />
              <Route path="/league/rounds" element={<RoundResultsController />} />
              <Route path="/league/prizes" element={<PrizeBoardController />} />
              <Route path="/stats/golfer" element={<GolferDetailView />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute />}>
              <Route path="" element={<MenuView />} />
              <Route path="menu" element={<MenuView />} />
              <Route path="org" element={<OrganizationController />} />
              <Route path="orgs" element={<OrganizationListView />} />
              <Route element={<OrgProtected />}>
                <Route path="courses" element={<CourseListView />} />
                <Route path="course" element={<CourseAdminController />} />
                <Route path="golfers" element={<GolferListView />} />
                <Route path="golfer" element={<GolferAdminController />} />
                <Route path="events" element={<EventListView />} />
                <Route path="events/archive" element={<ArchiveEventListView />} />
                <Route path="event" element={<EventController />} />
                <Route path="prizes" element={<PrizeListView />} />
                <Route path="prize" element={<PrizeAdminController />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </AppProvider>
    </GoogleOAuthProvider>
  )
}

export default App
